export default function PageSpinner({
  size = 36,
  label = "Loading",
}: { size?: number; label?: string }) {
  return (
    <div className="grid h-full place-items-center">
      <svg
        className="page-spinner"
        width={size}
        height={size}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={label}
        role="status"
      >
        <circle cx="25" cy="25" r="20" />
      </svg>
    </div>
  );
}
